import { render } from "./filesForm.vue?vue&type=template&id=5c679fb9&scoped=true"
import script from "./filesForm.vue?vue&type=script&lang=js"
export * from "./filesForm.vue?vue&type=script&lang=js"

import "./filesForm.vue?vue&type=style&index=0&id=5c679fb9&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\taxes-calculator\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c679fb9"]])

export default __exports__